import _ from 'lodash';
import { onVerifyPayment } from 'common/api/payment';
import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';
import { updateUrlQueryParams } from 'common/utils/urlUtils';

const PAID_STATUS = 'paid';
const SET_TIMEOUT_SECONDS = 2000;

const STATUS = {
  INITIATED: 'initiated',
  SUCCESS: 'success',
};

const CASHFREE_SDK_SRC = 'https://sdk.cashfree.com/js/v3/cashfree.js';

export const initializeCashfree = () => {
  return new Promise((resolve) => {
    if (window.Cashfree) {
      return resolve(true);
    }

    let script = document.querySelector(`script[src="${CASHFREE_SDK_SRC}"]`);

    if (script) {
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      return;
    }

    // Create fresh script
    script = document.createElement('script');
    script.src = CASHFREE_SDK_SRC;
    script.async = true;

    script.onload = () =>
      resolve(!!window.Cashfree); // true if Cashfree SDK attached

    script.onerror = () => resolve(false);

    document.body.appendChild(script);
  });
};


export const cashfreeModal = (args) => {
  initializeCashfree().then((loaded) => {
    if (!loaded || !window.Cashfree) {
      console.error('[Cashfree] SDK not loaded, loaded =', loaded, 'Cashfree =', window.Cashfree);
      reactToastify('Unable to load Cashfree payment SDK. Please try again.', TOASTIFY_TYPES.ERROR);
      return;
    }

    const onVerifyPurchase = (responseArgs) => {
      return onVerifyPayment(responseArgs);
    };

    updateUrlQueryParams('status', STATUS.INITIATED);

    const {
      gatewayExtras,  
      resyncTypes,
      cashfreePurchaseId,
    } = args;

    const immediateCallBackFunc = _.get(args, 'immediateCallBackFunc', () => { });

    console.log('[Cashfree] Starting checkout with args:', args);
    console.log('[Cashfree] Gateway extras:', gatewayExtras);

    const paymentSessionId = _.get(gatewayExtras, 'payment_session_id', '');
    if (!paymentSessionId) {
      console.error('[Cashfree] Missing payment_session_id in gatewayExtras');
      reactToastify('Unable to start payment. Please try again.', TOASTIFY_TYPES.ERROR);
      return;
    }

    const cashfree = new window.Cashfree({
      mode: window.SA_CONFIGS.cashFreeEnv || 'production', // 'production' or 'sandbox'
    });

    const checkoutConfig = {
      paymentSessionId,
      redirectTarget: '_modal'
    };

    console.log('[Cashfree] Checkout config:', checkoutConfig);

    cashfree
      .checkout(checkoutConfig)
      .then((response) => {
        console.log('[Cashfree] Checkout response:', response);

        return Promise.all(
          _.map(resyncTypes, (resyncType) => {
            return onVerifyPurchase({
              purchase_order_id: cashfreePurchaseId,
              type: resyncType,
              gateway: 'cashfree',
            })
              .then((result) => {
                const { status, message, purchase_status: purchaseStatus } = result;
                let toastMessage = '';
                let toastFormat = TOASTIFY_TYPES.SUCCESS;

                if (status && purchaseStatus === PAID_STATUS) {
                  toastMessage = message;
                } else if (status && purchaseStatus !== PAID_STATUS) {
                  toastMessage = `${message}, but not updated, please deploy a strategy after few minutes`;
                } else {
                  toastMessage = message;
                  toastFormat = TOASTIFY_TYPES.ERROR;
                }

                if (toastMessage) {
                  reactToastify(toastMessage, toastFormat);
                }
              })
              .catch((err) => {
                console.error('[Cashfree] onVerifyPurchase error:', err);
              });
          })
        );
      })
      .then(() => {
        setTimeout(() => {
          immediateCallBackFunc();
          updateUrlQueryParams('status', STATUS.SUCCESS);
        }, SET_TIMEOUT_SECONDS);
      })
      .catch((err) => {
        console.error('[Cashfree] Checkout error:', err);
        reactToastify('Payment was cancelled or failed. Please try again.', TOASTIFY_TYPES.ERROR);
      });
  });
};
